export default __webpack_public_path__ + "static/media/Jinesh.3d403152.jpg";